import { client } from "@/client/apollo";
import {
  CompleteSocraticTurnDocument,
  CompleteSocraticTurnMutation,
  CompleteSocraticTurnMutationVariables,
} from "@/generated/graphql";

/**
 * Store the uploaded response on its turn. A rejected turn is a resolved
 * `error` field on the payload, not a thrown error.
 */
export function completeSocraticTurn(
  variables: CompleteSocraticTurnMutationVariables
) {
  return client.mutate<
    CompleteSocraticTurnMutation,
    CompleteSocraticTurnMutationVariables
  >({
    mutation: CompleteSocraticTurnDocument,
    variables,
  });
}
